import React = require('react');
export const IconCircle = ({iconName, color}) => {
  return (
    <div className={color ? 'adm-icon-circle ' + color : 'adm-icon-circle'}>
      <img src={require(`./img/${iconName}`)} alt={''}/>
    </div>
  )
}
